var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-page-new',{attrs:{"title":_vm.$t('Headers')}},[_c('h5',[_vm._v("Headers list will be here")])])}
var staticRenderFns = []

export { render, staticRenderFns }